import React from "react";
import { Box, Card, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function PaymentSuccess() {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(to bottom, #f3f6fb 60%, #e8dcc8 100%)",
      }}
    >
      <Card
        sx={{
          width: 420,
          textAlign: "center",
          padding: 4,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 70, color: "#22c55e", mb: 2 }} />

        <Typography variant="h6" fontWeight={600}>
          Transaction Successful
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1, mb: 3 }}
        >
          Your payment has been processed successfully
        </Typography>
      </Card>
    </Box>
  );
}
